<a class="admin-shell__skip-link" href="#admin-main" data-testid="admin-shell-skip-link">Skip to content</a>
<header class="admin-shell__topbar">
  <img class="admin-shell__logo" src="assets/logo.png" alt="OwlHub Admin" data-testid="admin-shell-logo" />
  <div class="admin-shell__topbar-spacer"></div>
  <div class="admin-shell__topbar-actions">
    @if (accountHref) {
      <a
        mat-button
        class="admin-shell__account-link"
        data-testid="admin-shell-return-to-account"
        [href]="accountHref"
      >
        Back to my account
      </a>
    }
    <button
      mat-icon-button
      type="button"
      class="admin-shell__signout"
      aria-label="Sign out"
      data-testid="admin-shell-signout"
      (click)="onSignOut()"
    >
      <mat-icon aria-hidden="true">logout</mat-icon>
    </button>
  </div>
</header>
<aside class="admin-shell__aside" data-testid="admin-shell-aside">
  <ng-content select="[admin-nav]"></ng-content>
  <ng-content select="[admin-identity]"></ng-content>
</aside>
<main id="admin-main" tabindex="-1" class="admin-shell__main" data-testid="admin-shell-main">
  <ng-content></ng-content>
</main>
@if (open) {
  <aside class="admin-shell__companion" data-testid="admin-shell-companion">
    <ng-content select="[admin-companion]"></ng-content>
  </aside>
}
